<template>
  <ul class="sidebar-menu" id="sidebar-menu">

    <li :class="'pageLink '+(active == 'carte'?'active':'')">
      <router-link to="/map">
        <i class="fa fa-map"></i>
        <span class="page">Carte</span>
      </router-link>
    </li>

    <li :class="'pageLink '+(active == 'rondes'?'active':'')">
      <router-link to="/rondes">
        <i class="fa fa-map-signs"></i>
        <span class="page">Rondes</span>
      </router-link>
    </li>

    <li :class="'pageLink '+(active == 'agents'?'active':'')">
      <router-link to="/agents">
        <i class="fa fa-users"></i>
        <span class="page">Agents</span>
      </router-link>
    </li>

    <li :class="'pageLink '+(active == 'anomalies'?'active':'')">
      <router-link to="/anomalies">
        <i class="fa fa-exclamation-triangle"></i>
        <span class="page">Événements</span>
      </router-link>
    </li>

    <li :class="'pageLink '+(active == 'administrators'?'active':'')">
      <router-link to="/administrateurs">
        <i class="fa fa-user-secret"></i>
        <span class="page">Administrateurs</span>
      </router-link>
    </li>

    <li :class="'pageLink '+(active == 'reporting'?'active':'')">
      <router-link to="/reporting">
        <i class="fa fa-file"></i>
        <span class="page">Reporting</span>
      </router-link>
    </li>

    <li @click="logout()" class="pageLink pageLink--bottom">
      <a>
        <i class="fa fa-sign-out"></i>
        <span class="page">Déconnexion</span>
      </a>
    </li>

  </ul>
</template>

<script>
  export default {
    name: 'SidebarName',
    computed: {
      active () {
        switch (this.$route.name) {
          case 'Rondes' :
          case 'Ronde' :
            return 'rondes'
          case 'Carte' :
            return 'carte'
          case 'Agents' :
            return 'agents'
          case 'Anomalies' :
            return 'anomalies'
          case 'Administrateurs' :
            return 'administrators'
          case 'Reporting' :
            return 'reporting'
          default :
            return null
        }
      },
    },
    methods: {
      async logout () {
        // this.$store.commit('LOGOUT')
        // this.$router.push({name: 'login'})
        await this.$store.dispatch('logout')
        this.$router.push({name: 'Login'})
      },
    },
  }
</script>

<style lang="scss">
  @import '../scss/variables';

  #sidebar-menu {
    /* override default */
    .sidebar-menu > li > a {
      padding: 12px 15px 12px 15px;
    }

    .sidebar-menu > li.active > a {
      border-left-color: $suez-green !important;
      background-color: rgba($suez-white, .1) !important;
    }

    .sidebar-menu > li:hover > a {
      border-left-color: $suez-green !important;
      background-color: rgba($suez-white, .3) !important;
    }

    .sidebar-menu li.active > a > .fa-angle-left, .sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
      animation-name: rotate;
      animation-duration: .2s;
      animation-fill-mode: forwards;
    }

    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(-90deg);
      }
    }

    .pageLink--bottom {
      position: absolute;
      bottom: 10px;
      left: 0;
      right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?c0a5505e